// URL/filter-state helpers, mirroring Contract/List/utils/filterParams.js.
// Filter state keys are the exact backend query param names (search/
// buyer_type/payment_status/phase/linked/ordering) so no extra translation
// layer is needed between UI state, the URL query string, and the API
// params sent to getClients/getClientStats.

export const DEFAULT_ORDERING = "name";
export const DEFAULT_BUYER_TYPE = "NATURAL";

const STRING_PARAMS = ["search", "payment_status", "ordering"];
const NUMERIC_PARAMS = ["phase"];
const BOOLEAN_PARAMS = ["linked"];

// buyer_type is the "kind" switch driven by the sidebar's Natural/Legal
// Clients links (?buyer_type=natural / ?buyer_type=legal, lowercase) — read
// it separately and normalize to the backend's uppercase enum.
export const readParamsFromSearch = (searchParams) => {
  const params = { ordering: DEFAULT_ORDERING };

  const buyerType = searchParams.get("buyer_type");
  params.buyer_type = buyerType ? buyerType.toUpperCase() : DEFAULT_BUYER_TYPE;

  STRING_PARAMS.forEach((k) => {
    const v = searchParams.get(k);
    if (v) params[k] = v;
  });
  NUMERIC_PARAMS.forEach((k) => {
    const v = searchParams.get(k);
    if (v != null && v !== "" && !Number.isNaN(Number(v))) params[k] = Number(v);
  });
  BOOLEAN_PARAMS.forEach((k) => {
    const v = searchParams.get(k);
    if (v === "true") params[k] = true;
  });
  return params;
};

export const buildQueryString = (filterParams, page) => {
  const next = new URLSearchParams();
  if (page > 1) next.set("page", String(page));
  Object.entries(filterParams || {}).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    if (k === "ordering" && v === DEFAULT_ORDERING) return;
    if (k === "buyer_type" && v === DEFAULT_BUYER_TYPE) return;
    next.set(k, String(v));
  });
  return next;
};

export const paramsEqual = (a, b) => {
  const ka = Object.keys(a);
  const kb = Object.keys(b);
  return ka.length === kb.length && ka.every((k) => a[k] === b[k]);
};

// Sortable table-column id -> backend `ordering` field name. "next_payment"
// is a sentinel the backend special-cases (see ClientViewSet.filter_queryset),
// since SETTLED/UNSCHEDULED/NO_CONTRACTS clients all share next_payment_date=NULL.
export const ORDERING_FIELD_MAP = {
  name: "name",
  contracts: "contracts_count",
  next_payment: "next_payment",
  value: "total_value",
};

export const parseOrdering = (ordering) => {
  if (!ordering) return { field: null, dir: "asc" };
  const dir = ordering.startsWith("-") ? "desc" : "asc";
  const raw = dir === "desc" ? ordering.slice(1) : ordering;
  const field = Object.keys(ORDERING_FIELD_MAP).find((k) => ORDERING_FIELD_MAP[k] === raw) || null;
  return { field, dir };
};

export const buildOrdering = (field, dir) => {
  const backendField = ORDERING_FIELD_MAP[field] || field;
  return dir === "desc" ? `-${backendField}` : backendField;
};
